export function replacePlaceholderOnPath(path: string, placeholder: string, value: string) {
  return path.replace(placeholder, value);
}
